'use strict';
import React, { PureComponent } from 'react';

class RegistroProceso extends PureComponent {
    constructor(props) {
        super(props);
        this.cargarRegistrosEjecucionMostrarModalProceso = this.cargarRegistrosEjecucionMostrarModalProceso.bind(this);
    }

    cargarRegistrosEjecucionMostrarModalProceso() {
        this.props.cargarRegistrosDatosEjecucion(this.props.registro.TrazaEjecucion);
    }

    render() {
        const {
            registro
        } = this.props;

        let nombreProceso = registro.Descripcion;
        let estiloProcesoSinIniciar = !registro.FechaUltimoInicio ? " ContabilizadorRecontabilizador__nombreProceso--sinIniciar" : ""
        let estiloEstadoProceso = "";

        let fechaProceso = "";
        let fechaUltimoInicio = new Date(registro.FechaUltimoInicio);
        let fechaUltimoFin = new Date(registro.FechaUltimoFin);

        function formatearFecha(fecha)
        {
            let fechaFormateada = "";

            let anio = fecha.getFullYear();
            let mes = fecha.getMonth() + 1; // los meses se indexan desde 0
            let dia = fecha.getDate();

        // Agrega un cero delante del número del día y mes si es menor que 10
            let diaFormateado = dia < 10 ? `0${dia}` : dia;
            let mesFormateado = mes < 10 ? `0${mes}` : mes;

            return fechaFormateada = `${diaFormateado}/${mesFormateado}/${anio}`;
        }

        function formatearHora(hora)
        {
            let horaFormateada = "";

            let horas = hora.getHours();
            let minutos = hora.getMinutes();

            let horasFormateada = horas < 10 ? `0${horas}` : horas;
            let minutoFormateado = minutos < 10 ? `0${minutos}` : minutos;

            return horaFormateada = `${horasFormateada}:${minutoFormateado}`;
        }
        
        const diaUltimoInicio = fechaUltimoInicio.getDay();
        const diaUltimoFin = fechaUltimoFin.getDay();
        
        if (diaUltimoFin != diaUltimoInicio)
        {
            let diferenciaDiasEjecucion =  diaUltimoInicio - diaUltimoFin;

             fechaProceso = formatearFecha(fechaUltimoInicio) + " | " + formatearHora(fechaUltimoInicio) + " - " + formatearHora(fechaUltimoFin) + " +" + diferenciaDiasEjecucion + "D";
        }else
        {
             fechaProceso = formatearFecha(fechaUltimoInicio) + " | " + formatearHora(fechaUltimoInicio) + " - " + formatearHora(fechaUltimoFin);
        }

        switch (registro.ColorUltimaEjecucion) {
            case "VERDE":
                estiloEstadoProceso = " ContabilizadorRecontabilizador__registroProceso--ProcesoOk";
                break;
            case "ROJO":
                estiloEstadoProceso = " ContabilizadorRecontabilizador__registroProceso--ProcesoError";
                break;
            case "AZUL":
                estiloEstadoProceso = " ContabilizadorRecontabilizador__registroProceso--ProcesoEnEjecucion";
                break;        
            default:
                break;
        }
        
        return (
            <div>
                <div className={"AsientosContables--overflowHidden ContabilizadorRecontabilizador__registroProceso" + estiloEstadoProceso + (estiloProcesoSinIniciar ? " ContabilizadorRecontabilizador__registroProceso--procesoSeleccionado" : "")} onClick={!estiloProcesoSinIniciar ? this.cargarRegistrosEjecucionMostrarModalProceso : null}>
                    <div className={"AsientosContables--floatLeft ContabilizadorRecontabilizador__nombreProceso" + estiloProcesoSinIniciar}>{nombreProceso}</div>

                    {!estiloProcesoSinIniciar ?
                        <div className="AsientosContables--floatRight ContabilizadorRecontabilizador__fechaHoraEjecucion">{fechaProceso}</div>
                    :
                        null
                    }
                </div>
                
                {registro.MensajeUltimoRechazo ?
                    <div className="ContabilizadorRecontabilizador__contenedorLabel">
                        <label className="ContabilizadorRecontabilizador__labelError">{registro.MensajeUltimoRechazo}</label>
                    </div>
                :
                    null
                }
            </div>
        );
    }
}

export default RegistroProceso;